import AlertErrorIcon from './AlertError';
import CheckedIcon from './Checked';
import CloseIcon from './Close';
import CubeIcon from './Cube';
import SendIcon from './Send';
import TrashIcon from './Trash';

export { AlertErrorIcon, CheckedIcon, CloseIcon, CubeIcon, SendIcon, TrashIcon };



// WEBPACK FOOTER //
// ./src/components/Icons/index.js